// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import axios, { AxiosInstance } from "axios";

export class PublicAPIService {
  private static _instance: AxiosInstance;

  public static getInstance(): AxiosInstance {
    PublicAPIService._instance = axios.create();
    return PublicAPIService._instance;
  }
}
